import { useEffect, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'

import { useGetExperiment } from '../hooks'
import { useTrackOptimizelyExperimentEvent } from '../hooks/useTrackOptimizelyExperimentEvent'
import { EXPERIMENT_NAME_SERP_MIGRATION } from '../model/EXPERIMENT_NAME'

/**
 * as we are suspecting multiple activations and feature-flag-user-token
 * overwrite due to data discrepancies we need another metric/data
 * to compare the number of activations. This hook will track each user
 * only once if the experiment is enabled.
 */

const SERP_DEBUG_TRACKING_SENT_KEY = 'serp-debug-tracking-sent'
const EXPERIMENT_ACTIVATION_DELAY = 1000

export const useExperimentTrackSerpMigrationDebugEvent = (): void => {
  const [isTrackingEventAlreadySent, setIsTrackingEventAlreadySent] =
    useLocalStorage<boolean>(SERP_DEBUG_TRACKING_SENT_KEY, false)
  const [isOnClient, setIsOnClient] = useState<boolean>(false)

  useEffect(() => {
    setIsOnClient(true)
  }, [])

  const serpMigrationExperiment = useGetExperiment(
    EXPERIMENT_NAME_SERP_MIGRATION,
  )

  const trackOptimizelyEvent = useTrackOptimizelyExperimentEvent(
    'serp-migration-debug-event',
  )

  if (
    !isTrackingEventAlreadySent &&
    serpMigrationExperiment.isEnabled &&
    isOnClient
  ) {
    setIsTrackingEventAlreadySent(true)
    // wait 1 seconds to ensure the event is sent after the activation event
    setTimeout(() => {
      trackOptimizelyEvent()
    }, EXPERIMENT_ACTIVATION_DELAY)
  }
}
